<template>
  <v-app id="inspire">
    <v-main>
      <v-container fluid>
        <v-row class="mt-5">
          <v-col cols="4">
            <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y
              min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="dates" label="Дата оплаты" prepend-inner-icon="mdi-calendar" readonly
                  v-bind="attrs" v-on="on" outlined clearable></v-text-field>
              </template>
              <v-date-picker v-model="dates" range locale="ru-RU">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu = false">
                  Отмена
                </v-btn>
                <v-btn text color="primary" @click="$refs.menu.save(dates)">
                  Сохранить
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="4">
            <v-text-field label="Номер договора" v-model="numberDogFilter" outlined clearable></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-autocomplete label="Контакт" :items="contacts" v-model="selectContact" item-value="id" item-text="name"
              outlined clearable></v-autocomplete>
          </v-col>
          <v-col cols="4">
            <v-autocomplete label="Компания" :items="companys" v-model="selectCompany" item-value="id" item-text="name"
              outlined clearable></v-autocomplete>
          </v-col>
          <v-col cols="4">
            <v-select label="Направление" :items="category" v-model="selectCategory" outlined clearable item-value="id"
              item-text="name"></v-select>
          </v-col>
          <v-col cols="4">
            <v-select label="ОП" :items="OP" v-model="selectOP" outlined clearable item-value="id"
              item-text="name"></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-btn compact text color="primary" :loading="loading" class="flex-grow-1" height="48" tonal
              @click="getInvoice">Сформировать
              отчет</v-btn>
          </v-col>
          <v-col cols="4">
            <v-btn :disabled="loading" compact color="primary" class="flex-grow-1" height="48" tonal
              @click="saveXLS">Выгрузить
              XSL</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-data-table compact dense fixed-header :height="height" :items="items" :headers="headers"
              :items-per-page="25">
              <template v-slot:[`item.NameDeal`]="{ item }">
                <v-btn @click="toGo(item)" text>
                  {{ item.NameDeal }}
                </v-btn>
              </template>
              <template v-slot:items="props">
                <td>{{ props.item.OP }}</td>
                <td class="text-xs-right">{{ props.item.SumInvoice }}</td>
                <td class="text-xs-right">{{ props.item.income }}</td>
                <td class="text-xs-right">{{ props.item.expenses }}</td>
                <td class="text-xs-right">{{ props.item.OP }}</td>
                <td class="text-xs-right">{{ props.item.NameDeal }}</td>
                <td class="text-xs-right">{{ props.item.numberDog }}</td>
                <td class="text-xs-right">{{ props.item.dateDog }}</td>
                <td class="text-xs-right">{{ props.item.dateInvoce }}</td>
                <td class="text-xs-right">{{ props.item.bumberConclusion }}</td>
                <td class="text-xs-right">{{ props.item.ConclusionDate }}</td>
                <td class="text-xs-right">{{ props.item.actDate }}</td>
                <td class="text-xs-right">{{ props.item.summDeal }}</td>
                <td class="text-xs-right">{{ props.item.invoicer }}</td>
                <td class="text-xs-right">{{ props.item.company }}</td>
                <td class="text-xs-right">{{ props.item.income }}</td>
                <td class="text-xs-right">{{ props.item.expenses }}</td>
              </template>
              <template slot="body.append">
                <tr>
                  <th> {{ }}</th>
                  <th> {{ }}</th>
                  <th> {{ }}</th>
                  <th> {{ }}</th>
                  <th> {{ }}</th>
                  <th> {{ }}</th>
                  <th class="title">Итого:</th>
                  <th class="title"> {{ normalNum(sumDeal) }}</th>
                  <th> {{ }}</th>
                  <th class="title"> {{ normalNum(sumInv) }}</th>
                  <th> {{ }}</th>
                  <th> {{ }}</th>
                  <th class="title"> {{ normalNum(sumExpenses) }} </th>
                  <th class="title"> {{ normalNum(sumIncome) }} </th>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from 'axios';
import exceljs from 'exceljs'
import fileWrite from "file-saver"
import { BX24 } from "bx24";


export default {
  name: 'App',

  data: () => ({
    headers: [
      {
        text: 'ОП',
        value: 'OP',
        align: 'center',
        sortable: true
      },
      {
        text: 'Сделка',
        value: 'NameDeal',
        align: 'center',
        sortable: true
      },
      {
        text: 'Номер договора',
        value: 'numberDog',
        align: 'center',
        sortable: true
      },
      {
        text: 'Дата договора',
        value: 'dateDog',
        align: 'center',
        sortable: true
      },
      {
        text: 'Дата заключения',
        value: 'ConclusionDate',
        align: 'center',
        sortable: true
      },
      {
        text: 'Номер заключения',
        value: 'bumberConclusion',
        align: 'center',
        sortable: true
      },
      {
        text: 'Дата акта',
        value: 'actDate',
        align: 'center',
        sortable: true
      },
      {
        text: 'Сумма сделки',
        value: 'summDeal',
        align: 'center',
        sortable: true
      },
      {
        text: 'Дата платежа',
        value: 'dateInvoce',
        align: 'center',
        sortable: true
      },
      {
        text: 'Сумма платежа',
        value: 'SumInvoice',
        align: 'center',
        sortable: true
      },
      {
        text: 'Контакт',
        value: 'invoicer',
        align: 'center',
        sortable: true
      },
      {
        text: 'Компания',
        value: 'company',
        align: 'center',
        sortable: true
      },
      {
        text: 'Расходы',
        value: 'expenses',
        align: 'center',
        sortable: true
      },
      {
        text: 'Доходы',
        value: 'income',
        align: 'center',
        sortable: true
      },


    ],
    category: [
      { id: 0, name: 'Сделки с договорами' },
      { id: 8, name: 'ИП и КП' },
      { id: 24, name: 'Сметы СПБ' },
      { id: 18, name: 'Негос. Стройтехнология' },
      { id: 24, name: 'Сметы СПБ' },
      { id: 20, name: 'ОП Стройтехнология' },
      { id: 6, name: 'Копии и др.' },
      { id: 16, name: 'Судебные' },
      { id: 14, name: 'Суд. Стройка' },
    ],
    OP: [
      { id: 196, name: 'C' },
      { id: 198, name: 'ДВОП' },
      { id: 200, name: 'ПФО' },
      { id: 202, name: 'Чита' },
    ],
    selectOP: [],
    selectCategory: [],
    selectContact: '',
    selectCompany: '',
    items: [],
    reportItems: [],
    numberDog: [],
    contacts: [],
    companys: [],
    orders: [],
    dates: '',
    dates2: '',
    normalDate: [],
    loading: false,
    menu: false,
    menu2: false,
    invoicerFilter: '',
    numberDogFilter: '',
    deals: [],
    sumIncome: 0,
    sumExpenses: 0,
    company: [],
    filterReport: [],
    user: {},
    sumDeal: 0,
    sumInv: 0,
    users: [],
    auth: '',
    height: 0,
    url: 'https://sudexpert.bitrix24.ru/rest/7748/qpjkefb1bvi1du7d/'

  }),
  async mounted() {
    this.loading = true
    this.height = window.innerHeight * 0.6
    const bx24 = new BX24();
    this.auth = await bx24.getAuth();
    const user = await axios.post(this.url + "profile", {
      auth: this.auth.ACCESS_TOKEN,
    });
    this.user = user.data.result
    console.log(this.user, 'user')
    await this.getContact();
    await this.getCompany();
    await this.getOrder();
    await this.getUsers();
    this.loading = false
  },
  methods: {
    normalNum(number) {
      const formattedNumber = new Intl.NumberFormat('ru-RU', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(number);
      return formattedNumber
    },
    addSumResult(num, type) {
      if (num !== '') {
        let validNumber = num.replace(',', '.').replace(/\s/g, '');
        // Преобразуем строку в число
        let number = parseFloat(validNumber);
        if (type == 'sumInv') {
          this.sumInv += number
        }
        if (type == 'sumExp') {
          this.sumExpenses += number
        }
        if (type == 'sumInc') {
          this.sumIncome += number
        }
        if (type == 'sumDeal') {
          this.sumDeal += number
        }
        // Форматируем число в строку
        return number.toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
    },
    toGo(item) {
      window.open(`https://sudexpert.bitrix24.ru/crm/deal/details/${item.idDeal}/`);
    },
    async saveXLS() {
      const workbook = new exceljs.Workbook();
      const sheet = workbook.addWorksheet('report');
      const headers = []
      for (const head of this.headers) {
        headers.push({
          header: head.text, key: head.value, width: 18
        })
      }
      sheet.columns = headers
      for (const row of this.items) {
        const rowValues = [];
        rowValues[1] = row.OP
        rowValues[2] = row.NameDeal
        rowValues[3] = row.numberDog
        rowValues[4] = row.dateDog
        rowValues[5] = row.ConclusionDate
        rowValues[6] = row.bumberConclusion
        rowValues[7] = row.actDate
        rowValues[8] = row.summDeal
        rowValues[9] = row.dateInvoce
        rowValues[10] = row.SumInvoice
        rowValues[11] = row.invoicer
        rowValues[12] = row.company
        rowValues[13] = row.expenses
        rowValues[14] = row.income
        sheet.addRow(rowValues);
      }
      const rowValues = []
      rowValues[7] = 'Итого:'
      rowValues[8] = this.normalNum(this.sumDeal)
      rowValues[10] = this.normalNum(this.sumInv)
      rowValues[13] = this.normalNum(this.sumExpenses)
      rowValues[14] = this.normalNum(this.sumIncome)
      sheet.addRow(rowValues);
      const buffer = await workbook.xlsx.writeBuffer();
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const blob = new Blob([buffer], { type: fileType });
      fileWrite(blob, "report.xlsx");
    },
    formatDate(dateString) {
      if (dateString != '') {
        // Создаем объект Date из строки
        const date = new Date(dateString);

        // Получаем день, месяц и год
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Месяцы начинаются с 0
        const year = date.getFullYear();

        // Форматируем дату в нужный формат
        return `${day}.${month}.${year}`;
      }
    },
    async getContact() {
      console.log('go contacts')
      const req = await axios.post('https://spa-bitrix.ru/test/test2.php')
      for (const item of req.data) {
        this.contacts.push({ name: `${item.LAST_NAME ? item.LAST_NAME : ''} ${item.NAME ? item.NAME : ""} ${item.SECOND_NAME ? item.SECOND_NAME : ''}`, id: item.ID })
      }
    },
    async getCompany() {
      console.log('go company')
      const req = await axios.post('https://spa-bitrix.ru/test/company.php')
      for (const item of req.data) {
        this.companys.push({ name: item.TITLE, id: item.ID })
      }
    },
    async getOrder() {
      console.log('goOrder')
      const req = await axios.post('https://spa-bitrix.ru/test/getOrder.php')
      this.orders.push(...req.data)
    },
    async getUsers() {
      const params = {
        'FILTER': {
          ACTIVE: true
        }
      }
      const req = await axios.post(this.url + 'user.get', params)
      for (const user of req.data.result) {
        for (const dep of user.UF_DEPARTMENT) {
          if (dep == 198 || dep == 200 || dep == 202 || dep == 196 || dep == 178) {
            this.users.push({
              iduser: user.ID,
              idDepartament: dep
            })
          }
        }
      }
    },
    async getInvoice() {
      if (this.dates.length > 1) {
        this.sumDeal = 0
        this.sumExpenses = 0
        this.sumIncome = 0
        this.sumInv = 0
        this.reportItems = []
        this.loading = true
        const getOrder = await axios.post(
          "https://spa-bitrix.ru/test/getPay.php",
          {
            data1: this.dates[0],
            data2: this.dates[1],
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        const orders = []
        const nameDep = [
          {
            196: 'С',
            198: 'ДВОП',
            200: 'ПФО',
            202: 'Чита'
          }
        ]
        for (const order of getOrder.data) {
          orders.push(
            {
              idDeal: this.orders.filter((element) => element.orderId == order.id)[0].ownerId,
              NameDeal: '',
              numberDog: '',
              dateDog: '',
              dateInvoce: '',
              SumInvoice: '',
              invoicer: '',
              company: '',
              actDate: '',
              ConclusionDate: '',
              bumberConclusion: '',
              summDeal: '',
              OP: '',
              expenses: 0,
            }
          )
        }
        const batchParams = {
          halt: 0,
          cmd: {},
        };
        for (const orderItem in orders) {
          batchParams.cmd[
            'deal_' + orderItem
          ] = `crm.deal.get?id=${orders[orderItem].idDeal}`
          batchParams.cmd[
            'payment_' + orderItem
          ] = `crm.item.payment.list?entityId=${orders[orderItem].idDeal}&entityTypeId=2`
          if (orderItem % 25 == 0 || orderItem >= orders.length - 1) {
            const batchRes = await axios.post(this.url + "batch", batchParams)
            console.log(batchRes, 'batchRes')
            for (const dealsIndex in batchRes.data.result.result) {
              if (dealsIndex.includes('deal_')) {
                const index = dealsIndex.split('_')[1]
                const contact = this.contacts.filter((elem) => elem.id == batchRes.data.result.result['deal_' + index].CONTACT_ID)[0]
                const company = this.companys.filter((elem) => elem.id == batchRes.data.result.result['deal_' + index].COMPANY_ID)[0]
                const userOtdel = this.users.filter((elem) => elem.iduser == batchRes.data.result.result['deal_' + index].ASSIGNED_BY_ID)[0]
                orders[index].idContact = contact ? contact.id : ''
                orders[index].NameDeal = batchRes.data.result.result['deal_' + index].TITLE
                orders[index].numberDog = batchRes.data.result.result['deal_' + index].UF_CRM_1580701732 ? batchRes.data.result.result['deal_' + index].UF_CRM_1580701732 : batchRes.data.result.result['deal_' + index].UF_CRM_1715081044438 ? batchRes.data.result.result['deal_' + index].UF_CRM_1715081044438 : '',
                  orders[index].dateDog = this.formatDate(batchRes.data.result.result['deal_' + index].UF_CRM_1580784687, '')
                orders[index].CATEGORY_ID = batchRes.data.result.result['deal_' + index].CATEGORY_ID
                orders[index].invoicer = contact ? contact.name : ''
                orders[index].idContact = contact ? contact.id : ''
                orders[index].idCompany = company ? company.id : ''
                orders[index].company = company ? company.name : ''
                orders[index].idDepartament = userOtdel ? userOtdel.idDepartament : ''
                orders[index].actDate = this.formatDate(batchRes.data.result.result['deal_' + index].UF_CRM_1580915753, '')
                orders[index].ConclusionDate = this.formatDate(batchRes.data.result.result['deal_' + index].UF_CRM_1615821351, '')
                orders[index].bumberConclusion = batchRes.data.result.result['deal_' + index].UF_CRM_1581497425
                orders[index].summDeal = batchRes.data.result.result['deal_' + index].OPPORTUNITY
                orders[index].OP = userOtdel ? nameDep[0][userOtdel.idDepartament] : ''
                orders[index].ASSIGNED_BY_ID = batchRes.data.result.result['deal_' + index].ASSIGNED_BY_ID


                for (const payment of batchRes.data.result.result['payment_' + index]) {
                  let sumExpenses = 0
                  let sumIncome = 0
                  if (orders[index].idDepartament == '196') {
                    sumExpenses = payment.sum * 0.80;
                    sumIncome = payment.sum * 0.20;
                  } else if (orders[index].idDepartament == '198') {
                    sumExpenses = payment.sum * 0.88;
                    sumIncome = payment.sum * 0.12;
                  } else if (orders[index].idDepartament == '200') {
                    sumExpenses = payment.sum * 0.84;
                    sumIncome = payment.sum * 0.16;
                  } else if (orders[index].idDepartament == '202') {
                    sumExpenses = payment.sum * 0.84;
                    sumIncome = payment.sum * 0.16;
                  } else {
                    sumExpenses = 0; // Пример значения по умолчанию
                    sumIncome = payment.sum; // Пример значения по умолчанию
                  }
                  this.reportItems.push({
                    NameDeal: orders[index].NameDeal,
                    idDeal: orders[index].idDeal,
                    expenses: this.normalNum(sumExpenses),
                    income: this.normalNum(sumIncome),
                    numberDog: orders[index].numberDog,
                    dateDog: orders[index].dateDog,
                    dateInvoce: this.formatDate(payment.datePaid),
                    SumInvoice: this.normalNum(payment.sum),
                    invoicer: orders[index].invoicer,
                    company: orders[index].company,
                    idDepartament: orders[index].idDepartament,
                    idContact: orders[index].idContact,
                    idCompany: orders[index].idCompany,
                    CATEGORY_ID: orders[index].CATEGORY_ID,
                    actDate: orders[index].actDate,
                    ConclusionDate: orders[index].ConclusionDate,
                    bumberConclusion: orders[index].bumberConclusion,
                    summDeal: this.normalNum(orders[index].summDeal),
                    ASSIGNED_BY_ID: orders[index].ASSIGNED_BY_ID,
                    OP: orders[index].OP
                  })
                }
              }
            }
            batchParams.cmd = {};
          }
        }
        if (this.user.ADMIN) {
          this.filterReport = this.reportItems;
        } else {
          this.filterReport = this.reportItems.filter((elem) => elem.ASSIGNED_BY_ID == this.user.ID)
        }
        // Применяем фильтры последовательно
        if (this.selectCategory != '') {
          this.filterReport = this.filterReport.filter((elem) => elem.CATEGORY_ID == this.selectCategory);
        }
        if (this.selectCompany != '') {
          this.filterReport = this.filterReport.filter((elem) => elem.idCompany == this.selectCompany);
        }
        if (this.selectContact != '') {
          this.filterReport = this.filterReport.filter((elem) => elem.idContact == this.selectContact);
        }
        if (this.numberDogFilter != '') {
          this.filterReport = this.filterReport.filter((elem) => elem.numberDog == this.numberDogFilter);
        }
        if (this.selectOP != '') {
          this.filterReport = this.filterReport.filter((elem) => elem.idDepartament == this.selectOP);
        }
        // Если все фильтры пусты, возвращаем полный набор данных
        if (!(this.numberDogFilter || this.selectContact || this.selectCompany || this.selectCategory)) {
          if (this.user.ADMIN) {
            this.filterReport = this.reportItems;
          } else {
            this.filterReport = this.reportItems.filter((elem) => elem.ASSIGNED_BY_ID == this.user.ID)
          }
        }
        this.items = this.filterReport
        for (const itemSum of this.items) {
          this.addSumResult(itemSum.summDeal ? itemSum.summDeal : '', 'sumDeal')
          this.addSumResult(itemSum.SumInvoice ? itemSum.SumInvoice : '', 'sumInv')
          this.addSumResult(itemSum.expenses ? itemSum.expenses : '', 'sumExp')
          this.addSumResult(itemSum.income ? itemSum.income : '', 'sumInc')
        }
        this.loading = false
      } else {
        alert("Укажите диапазон дат")
      }
    }
  },
}
</script>
